/**
 * Mensagens do envio manual da Ficha de Cadastro Individual (F7c).
 *
 * Arquivo **sem imports** de propósito: `_esusCadastroPermissao.ts` depende de `auth`, que arrasta o
 * app inteiro (o barril de componentes puxa `@fullcalendar`, que o transformer do Jest não
 * processa). O diálogo precisa do texto, não do gate — então o texto mora aqui e o gate reexporta.
 */

/** Falta de permissão de verdade: o grupo do usuário não tem `Esus:cadastro`. */
export const MSG_SEM_PERMISSAO_ESUS_CADASTRO =
  'Você não tem permissão para enviar o cadastro do cidadão ao e-SUS APS. ' +
  'Solicite ao administrador da instituição a permissão "Esus:cadastro".'

/**
 * 403 **por sessão antiga**, distinto da falta de permissão de propósito.
 *
 * `Esus:cadastro` é permissão nova, semeada por `DataSeeder.loadPerfis` no boot, e a posse
 * `Esus:cadastro:<empresaId>` é assada no principal no momento da autenticação, com sessão
 * `STATELESS`: quem já estava logado antes do deploy toma 403 mesmo pertencendo a um grupo da lista.
 * Mandar essa pessoa "pedir permissão ao administrador" seria mandá-la para o lugar errado.
 */
export const MSG_403_SESSAO_ANTERIOR =
  'Sua sessão é anterior à liberação desta função. Saia e entre de novo no sistema para que a ' +
  'permissão de enviar cadastros ao e-SUS APS passe a valer. Se o erro continuar depois de relogar, ' +
  'peça ao administrador da instituição a permissão "Esus:cadastro".'
